import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ScrollState {
  private scrollProgressSubject = new BehaviorSubject<number>(0);
  scrollProgress$ = this.scrollProgressSubject.asObservable();

  setScrollProgress(progress: number) {
    this.scrollProgressSubject.next(progress);
  }
}
